export default __webpack_public_path__ + "static/media/info-deep-blue.610092d9.svg";